import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getDeliveryDetails } from '../../../../selectors/selectors'
import FormControl from '../FormControl/FormControl'

export default function LoggedInForm() {
  const { values } = useSelector(getDeliveryDetails)
  const { t } = useTranslation()
  const { register } = useForm({ defaultValues: values })

  return (
    <form>
      <FormControl inputRef={register()} isFieldDisabled label={t('deliveryDetails.form.email.label')} name="email" />
    </form>
  )
}
